var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H25C30.5228 0 35 4.47715 35 10V25C35 30.5228 30.5228 35 25 35H10C4.47715 35 0 30.5228 0 25V10Z",
    fill: "url(#paint0_linear_35297_846)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9034 12.1155L19.4586 20.0258L17.4921 22.8847H14.5883C14.3053 22.884 14.0271 22.8144 13.7804 22.6827C13.5338 22.5509 13.3268 22.3612 13.1792 22.1319L12.1371 20.5236L10.0957 17.3589L12.1371 17.3314L13.5687 17.3152L15.6015 20.5968L15.7406 20.3834L20.6622 12.8449C20.808 12.6213 21.0117 12.4368 21.2539 12.3092C21.4961 12.1815 21.7686 12.1148 22.0456 12.1155H24.9034Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35297_846",
    x1: 8.70837e-7,
    y1: 35,
    x2: 37.3735,
    y2: 2.72206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0D238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.c9a5a3f439ee5aef6dfb227eb7ab4002.svg";
export { ForwardRef as ReactComponent };